import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
    baseURL: API,
    headers: { "Content-Type": "application/json" },
});

export async function submitLead(payload) {
    const { data } = await api.post("/leads", payload);
    return data;
}

export async function listLeads(params = {}) {
    const { data } = await api.get("/leads", { params });
    return data;
}

export async function updateLeadStatus(id, status) {
    const { data } = await api.patch(`/leads/${id}`, { status });
    return data;
}

export async function getLeadStats() {
    const { data } = await api.get("/leads/stats");
    return data;
}

export async function calculateROI(payload) {
    const { data } = await api.post("/roi/calculate", payload);
    return data;
}
